import "./App.css";
import { NavigationRoute } from "./Navigation";
function App() {
  return <NavigationRoute />;
}

export default App;
